import { useEffect, useState } from 'react';
import { Menu, Divider, Checkbox } from 'semantic-ui-react';
import { Typography } from '@mui/material';
import { TextField, FormHelperText, Button } from '@mui/material';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import MessageModal from 'app/components/MessageModal';
import classes from 'app/components/UserProfile/classes.module.scss';

import {
  updateAccountPin
} from 'app/services/accounts';

import {
  updatePassword,
  updateUserName,
  updateMFAInfo,
  getMFARegistrationQR
} from 'shared/services/user';

import {
  updateName,
  updatePin
} from 'shared/actions/userActions';

const UserProfile = (props) => {
  const {
    user,
    updateName,
    updatePin,
    account
  } = props;

  const [username, setUsername] = useState(user.name);
  const [message, setMessage] = useState(null);
  const [showPass, setShowPass] = useState(false);
  const [confirmPass, setConfirmPass] = useState({});
  const [pin, setPin] = useState(user.pin);
  const [customPin, setCustomPin] = useState(false);
  const [passMessage, setPassMessage] = useState(null);
  const [newPinModal, setNewPinModal] = useState(false);
  const [mfaParams, setMfaParams] = useState({});
  const [qrCodeUri, setQRCodeUri] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!loaded) {
      getMFARegistrationQR().then((data) => {
        setQRCodeUri(data.url);
      })

      const obj = Object.assign({}, mfaParams);
      obj.id = user.id;
      obj.enable_mfa = user.enable_mfa;
      obj.user_mfa_secret = user.user_mfa_secret;
      setMfaParams(obj);
      setLoaded(true);
    }
  }, [loaded])

  const handleMFAParamsChange = (field, value) => {
    const obj = Object.assign({}, mfaParams);
    obj[field] = value;
    updateMFAInfo(obj).then(() => {
      getMFARegistrationQR().then((data) => {
        setQRCodeUri(data.url);
      })
      setMfaParams(obj);
    })
  }

  const handleSave = () => {
    try {
      // Update the password
      if (showPass && passMessage == null && (confirmPass != {} && confirmPass['new_password'] != '')) {
        updatePassword(confirmPass)
          .then(() => {
            showHidePassword();
            setMessage('User profile successfully updated');
          }).catch(err => {
            setPassMessage(err.error);
          });
      }

      // Update the user name
      if (username.trim() != '' && user.name !== username) {
        updateUserName({
          id: user.id,
          name: username
        }).then((data) => {
          // Update the user name in redux
          updateName(data.name);
          setMessage('User profile successfully updated');
        }).catch(err => {
          setMessage(err.error);
        });
      }
    } catch (err) {
      setMessage(err);
    }
  }

  const showHidePassword = () => {
    confirmPass['new_password'] = '';
    confirmPass['password_confirmation'] = '';

    setConfirmPass(confirmPass);
    setShowPass(!showPass);
  }

  const checkPass = (field, value) => {
    if (!showPass) {
      // DO NOTHING
      confirmPass['new_password'] = '';
      setConfirmPass(confirmPass);
      return;
    }

    value = value.trim();
    if (field == 'new_password') {
      confirmPass['new_password'] = value;
    } else {
      confirmPass['password_confirmation'] = value;
    }
    setConfirmPass(confirmPass);

    if (confirmPass['new_password'].length > 0 && confirmPass['new_password'].length < 6) {
      setPassMessage('Password needs to be at least six characters.');
    } else if (confirmPass['new_password'] !== confirmPass['password_confirmation']) {
      setPassMessage('Confirmed password does not match.');
    } else {
      setPassMessage(null);
    }
  }

  const updateUserPin = () => {
    let params = { account_id: account.id }
    if (customPin) {
      params.pin = pin;
    }

    updateAccountPin(account.id, params)
      .then((data) => {
        // Update the account pin in redux
        updatePin(data.pin);
        setPin(data.pin);
        setCustomPin(false);
        setMessage('Approval PIN successfully updated ');
      }).catch(err => {
        setMessage(err.error);
      });
  }

  const UpdatePassButton = () => (
    <Button
      variant='contained'
      size='medium'
      sx={{ height: '3em', width: '12em' }}
      onClick={showHidePassword}>
      {showPass ? 'Cancel' : 'Change'}
    </Button>
  )

  const UpdatePinButton = () => {
    let pinText = "New Pin"
    let click = () => setNewPinModal(true);
    if (customPin) {
      pinText = "Save Pin"
      click = updateUserPin
    }

    return (
      <Button
        variant='contained'
        size='medium'
        sx={{ height: '3em', width: '12em' }}
        onClick={click}>
        {pinText}
      </Button>
    )
  }

  const PinModal = () => {
    let title = "Generate New Pin";
    if (customPin) {
      title = 'Save New PIN';
    }

    return (
      <MessageModal
        isOpen={newPinModal}
        onClose={() => setNewPinModal(false)}
        title={title}
        headerVariant='h6'
        message='This will replace your PIN with a new one. Would you like to proceed?'
        onPrimaryButtonClick={updateUserPin}
      />
    )
  }

  return <div className={classes.container}>
    <Menu stackable secondary fluid>
      <Menu.Item>
        <Typography variant="h1">
          User Profile
        </Typography>
      </Menu.Item>
      <Menu.Menu position='right'>
        <Button
          variant='contained'
          size='medium'
          sx={{ height: '3em', width: '12em' }}
          onClick={handleSave}>
          Update Profile
        </Button>
      </Menu.Menu>
    </Menu>
    <Divider />
    <div>
      {user.name}
      <br />
      {user.email}
    </div>
    <br />
    <div className={classes.form}>
      <TextField
        defaultValue={user.name}
        label="User Name"
        variant="outlined"
        onChange={(e) => setUsername(e.target.value.trim())} />
      <br />
      <TextField
        error={showPass && passMessage != null}
        defaultValue={confirmPass['new_password']}
        type="password"
        label="New Password"
        variant="outlined"
        onChange={(e) => checkPass('new_password', e.target.value)}
        disabled={!showPass}
        InputProps={{ endAdornment: <UpdatePassButton /> }} />
      <br />
      {showPass &&
        <div className={classes.form}>
          <TextField
            error={passMessage != null}
            type="password"
            label="Confirm New Password"
            variant="outlined"
            onChange={(e) => checkPass('password_confirmation', e.target.value)}
            helperText={passMessage} />
          <br />
        </div>
      }
      <TextField
        value={pin || ''}
        label="Approval Pin"
        variant="outlined"
        InputProps={{ endAdornment: UpdatePinButton() }}
        onChange={
          (e) => {
            setCustomPin(true)
            setPin(e.target.value.trim())
          }
        } />
      <FormHelperText id="component-helper-text">
        This is your PIN for approving transactions.
      </FormHelperText>
      {
        account.feature_flags.two_factor_auth &&
        <div>
          <Checkbox toggle label='Enable 2-Factor Authentication' checked={mfaParams.enable_mfa} onChange={(e, { checked }) => {
            handleMFAParamsChange('enable_mfa', checked)
          }} />
          {
            mfaParams.enable_mfa && <img src={qrCodeUri} width={200} height={200} />
          }
        </div>
      }

    </div>
    <MessageModal
      isOpen={message !== null}
      onClose={() => setMessage(null)}
      title='User Profile Update'
      headerVariant='h6'
      message={message}
    />
    {PinModal()}
  </div>
}

const mapStateToProps = state => ({
  user: state.userReducer.user,
  account: state.portalReducer.account
});

export default connect(mapStateToProps, { updateName, updatePin })(withRouter(UserProfile));
